export default "__VITE_ASSET__DyaMihgC__"